import React, { useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { Editor } from '@tinymce/tinymce-react';

export default class Wsywig extends React.Component {
	constructor(props) {
		super(props);
		this.state = {error: null, value: "" };

	}
	
	onEditorChange = (content,editor) => {
		const { onChange, name } = this.props;
		if(onChange) {
			const customEvent = new CustomEvent('wysiwyg', { detail: {value:content, name: name } });
			Object.defineProperty(customEvent, 'target', {writable: false, value: {value:content, name: name }});
			onChange(customEvent);
		}
	}
	
	render() {
		const {value, name, onChange} = this.props;
		const initValue = value[name];
		return (
<Editor
		apiKey="28cfnsvmvlsh9xzy1hfqeinhwzha1php5spbj3ijv5k5o0es"
		value={initValue}
		onEditorChange={this.onEditorChange}
         init={{
           height: 500,
           menubar: false,
           plugins: [
             'advlist autolink lists link image charmap print preview anchor',
             'searchreplace visualblocks code fullscreen',
             'insertdatetime media table paste code help wordcount'
           ],
           toolbar: 'undo redo | formatselect | ' +
           'bold italic | alignleft aligncenter ' +
           'alignright alignjustify | bullist numlist outdent indent | ' +
           'removeformat',
           content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
         }}
       />			
		);
	}
}

Wsywig.defaultProps = {
	name:"",
	type: 'text',
	validation: false,
	placeholder: "",
	extraClass: "col mb-3",
	onChange: false,
	value: false,
};